export default __webpack_public_path__ + "static/slider-1-f757f0d1fbe30588385fde1726c651b3.jpg";